import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../../utils";
import { GetAllFaseAvvioFiltersDTO, GetAllFaseAvvioResponseData, GetAllFaseAvvioResponseDTO } from "./dataService/dto";
import { NewMonitoringFaseAvvioService } from "./dataService/service";

interface MonitoringFaseAvvioState {
    // FILTERS
    GetAllFaseAvvioFilters: GetAllFaseAvvioFiltersDTO
    getAllFaseAvvioStatus: PromiseStatuses
    GetAllFaseAvvioResponse?: GetAllFaseAvvioResponseData[]

}

const initialState: MonitoringFaseAvvioState = {

    GetAllFaseAvvioFilters: {
        itemsPerPage: 500,
        page: 0
    },

    getAllFaseAvvioStatus: 'idle',
}

export const GetAllFaseAvvio = createAsyncThunk(
    'monitoringFaseAvvio/GetAll',
    async (filters: GetAllFaseAvvioFiltersDTO, thunkApi): Promise<GetAllFaseAvvioResponseData[]> => {
        const monitoringFaseAvvioService = NewMonitoringFaseAvvioService()

        return monitoringFaseAvvioService.GetAllFaseAvvio(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const MonitoringFaseAvvioSlice = createSlice({
    name: 'monitoringFaseAvvio/slice',
    initialState,
    reducers: {
        // FILTERS
        setGetAllFaseAvvioFiltersItemsPerPage: (state, action) => {
            state.GetAllFaseAvvioFilters.itemsPerPage = action.payload
        },
        setGetAllFaseAvvioFiltersPage: (state, action) => {
            state.GetAllFaseAvvioFilters.page = action.payload
        },
        setGetAllFaseAvvioFiltersOrder: (state, action) => {
            state.GetAllFaseAvvioFilters.order = action.payload
        },
        setGetAllFaseAvvioFiltersSort: (state, action) => {
            state.GetAllFaseAvvioFilters.sort = action.payload
        },
        setGetAllFaseAvvioStartingDate: (state, action) => {
            state.GetAllFaseAvvioFilters.from = action.payload
        },
        setGetAllFaseAvvioEndingDate: (state, action) => {
            state.GetAllFaseAvvioFilters.to = action.payload
        },
        resetGetAllFaseAvvioFilters: (state) => {
            state.GetAllFaseAvvioFilters = {
                itemsPerPage: 500,
                page: 0
            }
        },
    },
    extraReducers(builder) {
        builder

            // GET ALL
            .addCase(GetAllFaseAvvio.pending, (state) => {
                state.getAllFaseAvvioStatus = 'loading'
            })
            .addCase(GetAllFaseAvvio.fulfilled, (state, action) => {
                state.getAllFaseAvvioStatus = 'successfully'
                state.GetAllFaseAvvioResponse = action.payload
            })
            .addCase(GetAllFaseAvvio.rejected, (state) => {
                state.getAllFaseAvvioStatus = 'failed'
            })

    },
})

export const {
setGetAllFaseAvvioEndingDate,
setGetAllFaseAvvioFiltersItemsPerPage,
setGetAllFaseAvvioFiltersOrder,
setGetAllFaseAvvioFiltersPage,
setGetAllFaseAvvioFiltersSort,
setGetAllFaseAvvioStartingDate,
resetGetAllFaseAvvioFilters
} = MonitoringFaseAvvioSlice.actions

export default MonitoringFaseAvvioSlice.reducer